import {
    all,
    put,
    takeEvery,
    take,
    spawn,
    delay,
    cancelled,
    cancel,
    fork,
    select,
} from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { postman } from '../utils/postman';
import { history } from '../store/historyInstance';
import {
    DICTIONARY_TARIFFS_LIST_LINK,
    DICTIONARY_ARTICLES_LIST_LINK,
    DICTIONARY_LIST_LINK,
    FIELDS_SETTING_LINK,
    DICTIONARY_SETTING_LINK,
    ROLES_LINK,
    USERS_LINK,
    SETTINGS_LINK,
    SCENARIO_SETTING_LINK,
    NOTIFICATIONS_SETTING_LINK
} from '../router/links';
import { logoutRequest } from './login';
import { toast } from 'react-toastify';
import { errorMapping } from '../utils/errorMapping';
import { openSelector } from './representations';
import {
    ADDITIONAL_POINTS_COST_REPORT_TYPE,
    ALLOCATIONS_PLAN_ACTUAL_INDICATORS_REPORT_TYPE,
    ALLOCATIONS_SUMMARY_ACTUAL_PLAN_REPORT_TYPE, DIRECTION_ALLOCATIONS_PLAN_ACTUAL_REPORT_TYPE, FAILURE_REPORT_TYPE, REFUSAL_REPORT_TYPE,
    OPERATIONAL_REPORT_TYPE, ORDER_ADDING_TO_TRANSPORTATIONS_REPORT_TYPE,
    REGISTRY_REPORT_TYPE,
    SHIPMENT_REGISTRY_REPORT_TYPE, SHIPPING_DETAILED_COSTS_REPORT_TYPE,
    SHIPPING_DETAILED_POINTS_REPORT_TYPE,
    RENTAL_ACTUAL_DATES_REPORT_TYPE,
    CLAIMS_REPORT_TYPE
} from '../constants/reportType';
import { sortFunc } from '../utils/sort';
import OrderAddingToTransportationsHistory
    from "../containers/customGrid/components/orderTabs/OrderAddingToTransportationsHistory";

const TYPE_API = 'profile';

//*  TYPES  *//
export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST';
const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
const GET_USER_PROFILE_ERROR = 'GET_USER_PROFILE_ERROR';

const GET_PROFILE_SETTINGS_REQUEST = 'GET_PROFILE_SETTINGS_REQUEST';
const GET_PROFILE_SETTINGS_SUCCESS = 'GET_PROFILE_SETTINGS_SUCCESS';
const GET_PROFILE_SETTINGS_ERROR = 'GET_PROFILE_SETTINGS_ERROR';

const EDIT_PROFILE_SETTINGS_REQUEST = 'EDIT_PROFILE_SETTINGS_REQUEST';
const EDIT_PROFILE_SETTINGS_SUCCESS = 'EDIT_PROFILE_SETTINGS_SUCCESS';
const EDIT_PROFILE_SETTINGS_ERROR = 'EDIT_PROFILE_SETTINGS_ERROR';

const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

const GET_NOTIFICATIONS_LIST_REQUEST = 'GET_NOTIFICATIONS_LIST_REQUEST';
const GET_NOTIFICATIONS_LIST_SUCCESS = 'GET_NOTIFICATIONS_LIST_SUCCESS';
const GET_NOTIFICATIONS_LIST_ERROR = 'GET_NOTIFICATIONS_LIST_ERROR';

const GET_SETTINGS_COMPANIES_REQUEST = 'GET_SETTINGS_COMPANIES_REQUEST';
const GET_SETTINGS_COMPANIES_SUCCESS = 'GET_SETTINGS_COMPANIES_SUCCESS';
const GET_SETTINGS_COMPANIES_ERROR = 'GET_SETTINGS_COMPANIES_ERROR';

const START_AUTO_UPDATE = 'START_AUTO_UPDATE';
const STOP_AUTO_UPDATE = 'STOP_AUTO_UPDATE';

const CLEAR_ERROR = 'CLEAR_ERROR';
const ADD_ERROR = 'ADD_ERROR';

const DEFAULT_STATE = 'DEFAULT_STATE';

let taskUpdateConfig = null;

//*  INITIAL STATE  *//

const initial = {
    progress: false,
    data: {},
    notifications: [],
    companies: [],
    error: [],
    progressEdit: false,
    progressChangePassword: false,
    isPasswordExpired: false
};

//*  REDUCER  *//

export default (state = initial, { type, payload }) => {
    switch (type) {
        case GET_USER_PROFILE_REQUEST:
            return {
                ...state,
                progress: true,
            };
        case GET_USER_PROFILE_SUCCESS:
            return {
                ...state,
                progress: false,
                ...payload,
            };
        case GET_USER_PROFILE_ERROR:
            return {
                ...state,
                progress: false,
            };
        case GET_PROFILE_SETTINGS_SUCCESS:
            return {
                ...state,
                data: payload,
            };
        case CLEAR_ERROR:
            return {
                ...state,
                error: state.error && state.error.filter(item => item.name !== payload),
            };
        case ADD_ERROR:
            return {
                ...state,
                error: [...state.error, payload],
            };
        case EDIT_PROFILE_SETTINGS_REQUEST:
            return {
                ...state,
                progressEdit: true,
            };
        case EDIT_PROFILE_SETTINGS_SUCCESS:
            return {
                ...state,
                progressEdit: false,
                error: [],
            };
        case EDIT_PROFILE_SETTINGS_ERROR:
            return {
                ...state,
                progressEdit: false,
                error: payload,
            };
        case CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                progressChangePassword: true,
            };
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                error: [],
                progressChangePassword: false,
            };
        case CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                error: payload,
                progressChangePassword: false,
            };
        case GET_NOTIFICATIONS_LIST_SUCCESS:
            return {
                ...state,
                notifications: payload,
            };

        case GET_SETTINGS_COMPANIES_REQUEST:
            return {
                ...state,
                progressCompanies: true,
            };
        case GET_SETTINGS_COMPANIES_SUCCESS:
            return {
                ...state,
                companies: payload,
                progressCompanies: false,
                error: [],
            };
        case GET_SETTINGS_COMPANIES_ERROR:
            return {
                ...state,
                progressCompanies: false,
                error: payload,
            };
        case DEFAULT_STATE:
            return {
                ...initial,
            };
        default:
            return state;
    }
};

//*  ACTION CREATORS  *//

export const getUserProfile = payload => {
    return {
        type: GET_USER_PROFILE_REQUEST,
        payload,
    };
};

export const getProfileSettingsRequest = payload => {
    return {
        type: GET_PROFILE_SETTINGS_REQUEST,
        payload,
    };
};

export const editProfileSettingsRequest = payload => {
    return {
        type: EDIT_PROFILE_SETTINGS_REQUEST,
        payload,
    };
};

export const changePasswordRequest = payload => {
    return {
        type: CHANGE_PASSWORD_REQUEST,
        payload,
    };
};

export const clearError = payload => {
    return {
        type: CLEAR_ERROR,
        payload,
    };
};

export const addError = payload => {
    return {
        type: ADD_ERROR,
        payload,
    };
};

export const getNotificationsListRequest = () => {
    return {
        type: GET_NOTIFICATIONS_LIST_REQUEST,
    };
};

export const getSettingsCompaniesRequest = () => {
    return {
        type: GET_SETTINGS_COMPANIES_REQUEST,
    };
};

export const startAutoUpdateConfigRequest = () => {
    return {
        type: START_AUTO_UPDATE,
    };
};

export const stopAutoUpdateConfigRequest = () => {
    return {
        type: STOP_AUTO_UPDATE,
    };
};

//*  SELECTORS *//

const stateSelector = state => state.profile;

export const profileSelector = createSelector(
    stateSelector,
    state => state,
);

export const gridsMenuSelector = createSelector(
    stateSelector,
    state => state.grids,
);

export const dictionariesSettingsSelector = createSelector(
    stateSelector,
    state => state.dictionaries,
);

export const dictionariesMenuSelector = createSelector(
    [stateSelector, (state, t) => t],
    (state, t) => {
        let items = state.dictionaries
            ? state.dictionaries
                .filter(dictionary => !dictionary.showOnHeader && !dictionary.hideOnMenu)
            : [];

        const nameLinks = [
            {
                name: 'roles',
                link: ROLES_LINK
            },
            {
                name: 'articles',
                link: DICTIONARY_ARTICLES_LIST_LINK
            },
            {
                name: 'users',
                link: USERS_LINK
            }
        ]

        let dictionaries = {
            groups: [],
            others: []
        };

        const dictionariesSort = sortFunc(items, t, 'displayName');

        (dictionariesSort || []).forEach(dictionary => {
            const nameLink = nameLinks.find(nl => nl.name === dictionary.name)
            const d = {
                name: dictionary.name,
                displayName: dictionary.displayName,
                link: nameLink ? nameLink.link
                    : DICTIONARY_LIST_LINK.replace(':name', dictionary.name)
            };

            if (dictionary.groupKey) {
                const group = dictionaries.groups.find(gr => gr.name === dictionary.groupKey);
                group ? group.items.push(d)
                    : dictionaries.groups.push({ name: dictionary.groupKey, items: [d] });
            } else dictionaries.others.push(d);
        });

        return dictionaries;
    }
);

export const dictionariesHeaderSelector = createSelector(
    [stateSelector, (state, t) => t],
    (state, t) => {
        let items = state.dictionaries
            ? state.dictionaries
                .filter(dictionary => dictionary.showOnHeader && !dictionary.hideOnMenu)
                .map(dictionary => ({
                    name: dictionary.name,
                    displayName: dictionary.displayName,
                    link: DICTIONARY_LIST_LINK.replace(':name', dictionary.name)
                }))
            : [];
        return sortFunc(items, t, 'displayName');
    }
);

export const gridsSelector = createSelector(
    stateSelector,
    state => state.grids && state.grids.map(grid => grid.name),
);

export const dictionariesSelector = createSelector(
    stateSelector,
    state => state.dictionaries && state.dictionaries.map(dictionary => dictionary.name),
);

export const instructionsSelector = createSelector(
    stateSelector,
    state => state.instructions,
)

export const isCustomPageSelector = createSelector(
    stateSelector,
    state => {
        return {
            fieldsSettings: state.fieldsSettings,
            dictionarySettings: state.dictionarySettings,
            scenariosSetting: state.scenariosSetting,
            notificationSetting: state.notificationSetting,
            companySettings: state.companySettings,
            claimIncidentsColumns: state.claimIncidentsColumns,
            editRoles: state.editRoles,
            editUsers: state.editUsers,
            editArticles: state.editArticles,
            editShippingWarehouses: state.editShippingWarehouses,
            editTariffs: state.editTariffs,
            editDriverVehicles: state.editDriverVehicles,
            editTerminalBandwidth: state.editTerminalBandwidth,
            editTariffAdditionalCosts: state.editTariffAdditionalCosts,
            calculateDeliveryToForwarder: state.calculateDeliveryToForwarder,
            shippingsViewOrders: state.shippingsViewOrders,
            shippingsViewRequests: state.shippingsViewRequests,
            shippingsEditReturns: state.shippingsEditReturns,
            shippingsViewCostChanges: state.shippingsViewCostChanges,
            shippingsEditAdditionalCosts: state.shippingsEditAdditionalCosts,
            shippingOrdersColumns: state.shippingOrdersColumns,
            shippingRequestsColumns: state.shippingRequestsColumns,
            orderAddingToTransportationsHistoryColumns: state.orderAddingToTransportationsHistoryColumns,
            shippingCostHistoryColumns: state.shippingCostHistoryColumns,
            deliveryCostRequestsColumns: state.deliveryCostRequestsColumns,
            importShippingVehicle: state.importShippingVehicle,
            shippingsExportCarrierDocuments: state.shippingsExportCarrierDocuments,
            poolingIntegrationInstruction: state.poolingIntegrationInstruction,
            poolingIntegrationInstructionUrl: state.poolingIntegrationInstructionUrl,
            profile: true,
            autogroupingOrders: state.autogroupingOrders,
            [OPERATIONAL_REPORT_TYPE]: state.viewOperationalReport,
            [ALLOCATIONS_SUMMARY_ACTUAL_PLAN_REPORT_TYPE]: state.viewAllocationsSummaryActualPlanReport,
            [ALLOCATIONS_PLAN_ACTUAL_INDICATORS_REPORT_TYPE]: state.viewAllocationsPlanActualIndicatorsReport,
            [DIRECTION_ALLOCATIONS_PLAN_ACTUAL_REPORT_TYPE]: state.viewDirectionAllocationsPlanActualReport,
            [FAILURE_REPORT_TYPE]: state.viewFailureReport,
            [REFUSAL_REPORT_TYPE]: state.viewRefusalReport,
            [ORDER_ADDING_TO_TRANSPORTATIONS_REPORT_TYPE]: state.viewOrderAddingToTransportationsReport,
            [SHIPPING_DETAILED_COSTS_REPORT_TYPE]: state.viewShippingDetailedCostsReport,
            [ADDITIONAL_POINTS_COST_REPORT_TYPE]: state.viewAdditionalPointsCostReport,
            [REGISTRY_REPORT_TYPE]: state.viewRegistryReport,
            [SHIPMENT_REGISTRY_REPORT_TYPE]: state.viewRegistryReport,
            [SHIPPING_DETAILED_POINTS_REPORT_TYPE]: state.ShippingDetailedPointsReport,
            [RENTAL_ACTUAL_DATES_REPORT_TYPE]: state.RentalActualDatesReport,
            [CLAIMS_REPORT_TYPE]: state.ClaimsReport,
        };
    },
);

export const otherMenuSelector = createSelector(
    stateSelector,
    state => {
        const menu = [];
        if (state.notificationSetting) {
            menu.push({
                name: 'notifications_setting',
                link: NOTIFICATIONS_SETTING_LINK,
            });
        }
        if (state.fieldsSettings) {
            menu.push({
                name: 'fields_setting',
                link: FIELDS_SETTING_LINK,
            });
        }
        if (state.dictionarySettings) {
            menu.push({
                name: 'dictionary_setting',
                link: DICTIONARY_SETTING_LINK,
            });
        }
        if (state.scenariosSetting) {
            menu.push({
                name: 'scenario_setting',
                link: SCENARIO_SETTING_LINK,
            });
        }

        return menu;
    },
);

export const companiesSelector = createSelector(stateSelector, state => state.companies);

export const isPasswordExpiredSelector = createSelector(stateSelector, state => state.isPasswordExpired);

export const companySettingsMenuSelector = createSelector(
    stateSelector,
    state => {
        const menu = [];
        if (state.companySettings && state.companies) {
            return state.companies.map(company => 
            ({
                name: company.name,
                link: SETTINGS_LINK.replace(':companyId', company.value)
            }));
        }

        return [];
    },
);

export const userLoginSelector = createSelector(
    stateSelector,
    state => state.userLogin,
);
export const userNameSelector = createSelector(
    stateSelector,
    state => state.userName,
);
export const roleSelector = createSelector(
    stateSelector,
    state => state.userRole,
);
export const roleIdSelector = createSelector(
    stateSelector,
    state => state.role && state.role.id,
);

export const rolesAndUsersMenu = createSelector(
    stateSelector,
    state => {
        let menu = [];

        if (state.editRoles) {
            menu.push({
                name: 'roles',
                link: ROLES_LINK
            });
        }

        if (state.editArticles) {
            menu.push({
                name: 'articles',
                link: DICTIONARY_ARTICLES_LIST_LINK
            });
        }

        if (state.editUsers) {
            menu.push({
                name: 'users',
                link: USERS_LINK,
            });
        }

        if (state.editTariffs) {
            menu.push({
                name: 'Tariffs',
                link: DICTIONARY_TARIFFS_LIST_LINK
            });
        }

        return menu;
    },
);

export const dataLoadingMenuSelector = createSelector(
    stateSelector,
    state => {
        let menu = [];

        if (state.importShippingVehicle) {
            menu.push({
                name: 'drivers_and_vehicles',
                typeApi: 'shippingVehicle',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.importOrders) {
            menu.push({
                name: state.importOrdersTitle,
                typeApi: 'orders',
                items: [
                    {
                        name: 'template_settings',
                        type: 'template_settings',
                    },
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.poolingWarehousesImport) {
            menu.push({
                name: 'poolingWarehousesImport',
                typeApi: 'poolingWarehouses',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.invoiceImport) {
            menu.push({
                name: 'invoices',
                typeApi: 'invoices',
                items: [
                    {
                        name: 'instruction',
                        type: 'instruction',
                        fileName: 'invoice_howto.pdf',
                    },
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.importShippings) {
            menu.push({
                name: state.importShippingsTitle,
                typeApi: 'shippings',
                items: [
                    {
                        name: 'template_settings',
                        type: 'template_settings',
                    },
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.importTariffsAbie) {
            menu.push({
                name: 'tariffs',
                typeApi: 'tariffsAbie',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loader'
                    },
                ],
            });
        }

        if (state.importFixedDirectionsAbie) {
            menu.push({
                name: 'fixedDirectionsAbie',
                typeApi: 'fixedDirectionsAbie',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.importShippingsAbie) {
            menu.push({
                name: 'shippingsAbie',
                typeApi: 'shippingsAbie',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.importProfitableDirections) {
            menu.push({
                name: 'profitableDirections',
                typeApi: 'profitableDirections',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.importRentedVehicles) {
            menu.push({
                name: 'rentedVehicles',
                typeApi: 'rentedVehicles',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        if (state.importGosLogRegistry) {
            menu.push({
                name: 'gosLogRegistry',
                typeApi: 'gosLogRegistry',
                items: [
                    {
                        name: 'Template upload',
                        type: 'unloading',
                    },
                    {
                        name: 'data_loading',
                        type: 'loading',
                    },
                ],
            });
        }

        return menu;
    },
);

export const reportsMenuSelector = createSelector(
    stateSelector,
    state => {
        let menu = [];

        if (state.viewOperationalReport) {
            menu.push({
                name: 'Operational report',
                type: OPERATIONAL_REPORT_TYPE,
            });
        }

        if (state.viewRegistryReport) {
            menu.push({
                name: 'Registry report',
                type: REGISTRY_REPORT_TYPE,
            });
        }

        if (state.viewShipmentRegistryReport) {
            menu.push({
                name: 'Shipment registry report',
                type: SHIPMENT_REGISTRY_REPORT_TYPE,
            });
        }

        if (state.viewAllocationsSummaryActualPlanReport) {
            menu.push({
                name: 'Allocations summary actual plan report',
                type: ALLOCATIONS_SUMMARY_ACTUAL_PLAN_REPORT_TYPE,
            });
        }

        if (state.viewAllocationsPlanActualIndicatorsReport) {
            menu.push({
                name: 'Allocations plan actual indicators report',
                type: ALLOCATIONS_PLAN_ACTUAL_INDICATORS_REPORT_TYPE,
            });
        }

        if (state.viewDirectionAllocationsPlanActualReport) {
            menu.push({
                name: 'Direction allocations plan actual report',
                type: DIRECTION_ALLOCATIONS_PLAN_ACTUAL_REPORT_TYPE,
            });
        }

        if (state.viewFailureReport) {
            menu.push({
                name: 'Failure report',
                type: FAILURE_REPORT_TYPE,
            });
        }

        if (state.viewOrderAddingToTransportationsReport) {
            menu.push({
                name: 'Order adding to transportations report',
                type: ORDER_ADDING_TO_TRANSPORTATIONS_REPORT_TYPE,
            });
        }

        if (state.viewShippingDetailedCostsReport) {
            menu.push({
                name: 'Shipping detailed costs report',
                type: SHIPPING_DETAILED_COSTS_REPORT_TYPE,
            });
        }

        if (state.viewAdditionalPointsCostReport) {
            menu.push({
                name: 'Additional points cost report',
                type: ADDITIONAL_POINTS_COST_REPORT_TYPE,
            });
        }

        if (state.viewRefusalReport) {
            menu.push({
                name: 'Refusal report',
                type: REFUSAL_REPORT_TYPE,
            });
        }

        if (state.viewShippingDetailedPointsReport) {
            menu.push({
                name: 'Shipping detailed points report',
                type: SHIPPING_DETAILED_POINTS_REPORT_TYPE,
            });
        }

        if (state.viewRentalActualDatesReport) {
            menu.push({
                name: 'Rental actual dates report',
                type: RENTAL_ACTUAL_DATES_REPORT_TYPE,
            });
        }

        if (state.viewClaimsReport) {
            menu.push({
                name: 'Claims report',
                type: CLAIMS_REPORT_TYPE,
            });
        }

        return menu;
    },
);

export const homePageSelector = createSelector(
    stateSelector,
    state => {
        let homePage = '/grid';
        if (state.grids && state.grids.length) {
            homePage = `/grid/${state.grids[0].name}`;
        } else if (state.dictionaries && state.dictionaries.length) {
            homePage = `/dictionary/${state.dictionaries[0].name}`;
        } else if (state.editRoles) {
            homePage = '/roles';
        } else if (state.editUsers) {
            homePage = '/users';
        } else if (state.editArticles) {
            homePage = '/articles';
        } else if (state.editTariffs) {
            homePage = '/tariffs';
        } else if (state.editShippingWarehouses) {
            homePage = '/shippingWarehouses';
        }
        return homePage;
    },
);

export const userPermissionsSelector = createSelector(
    stateSelector,
    state => {
        return state.role ? state.role.permissions.map(item => item.code) : [];
    },
);

export const profileSettingsSelector = createSelector(
    stateSelector,
    state => state.data,
);

export const progressEditSelector = createSelector(
    stateSelector,
    state => state.progressEdit,
);

export const progressChangePasswordSelector = createSelector(
    stateSelector,
    state => state.progressChangePassword,
);

export const errorSelector = createSelector(
    stateSelector,
    state => errorMapping(state.error),
);

export const notificationsSelector = createSelector(
    stateSelector,
    state => state.notifications,
);

export const backlightsConfigSelector = createSelector(
    stateSelector,
    state => state.backlightsConfig || {},
);

//*  SAGA  *//

export function* getUserProfileSaga({ payload = {} }) {
    try {
        const { url, isNotCofigUpdate } = payload;
        const userInfo = yield postman.get('/identity/userInfo');
        const config = isNotCofigUpdate ? {} : yield postman.get('/appConfiguration');

        yield put({
            type: GET_USER_PROFILE_SUCCESS,
            payload: { ...userInfo, ...config },
        });
        if (url) {
            history.push(url);
        }
    } catch (e) {
        yield put({
            type: GET_USER_PROFILE_ERROR,
            payload: e,
        });
        if (e && e.response && e.response.status >= 400 && e.response.status < 500) {
            yield put(logoutRequest()); // todo
        }
    }
}

function* getProfileSettingsSaga() {
    try {
        const result = yield postman.get(`/${TYPE_API}/info`);

        yield put({
            type: GET_PROFILE_SETTINGS_SUCCESS,
            payload: result,
        });
    } catch (e) {
        yield put({
            type: GET_PROFILE_SETTINGS_ERROR,
        });
    }
}

function* editProfileSettingsSaga({ payload }) {
    try {
        const { form, callbackSuccess } = payload;
        const result = yield postman.post(`/${TYPE_API}/save`, form);

        if (result.isError) {
            toast.error(result.message);
            yield put({
                type: EDIT_PROFILE_SETTINGS_ERROR,
                payload: result.errors,
            });
        } else {
            yield put({
                type: EDIT_PROFILE_SETTINGS_SUCCESS,
                payload: result,
            });

            yield put({
                type: GET_USER_PROFILE_SUCCESS,
                payload: { userName: form.userName },
            });

            callbackSuccess && callbackSuccess();
        }
    } catch (e) {
        yield put({
            type: EDIT_PROFILE_SETTINGS_ERROR,
        });
    }
}

function* changePasswordSaga({ payload }) {
    try {
        const { form, callbackSuccess, t } = payload;
        const result = yield postman.post(`/identity/newpassword`, form);

        if (result.isError) {
            toast.error(result.message);

            yield put({
                type: CHANGE_PASSWORD_ERROR,
                payload: result.errors,
            });
        } else {
            toast.info(t('changePasswordSuccess'));

            yield put({
                type: CHANGE_PASSWORD_SUCCESS,
                payload: result,
            });

            callbackSuccess && callbackSuccess();
        }
    } catch (e) {
        yield put({
            type: CHANGE_PASSWORD_ERROR,
        });
    }
}

function* getNotificationsListSaga({ payload }) {
    try {
        const result = yield postman.get(`/${TYPE_API}/allNotifications`);

        yield put({
            type: GET_NOTIFICATIONS_LIST_SUCCESS,
            payload: result,
        });
    } catch (e) {
        yield put({
            type: GET_NOTIFICATIONS_LIST_ERROR,
        });
    }
}

function* getCompaniesSaga({ payload }) {
    try {
        const result = yield postman.get(`/companies/forSelect`);

        yield put({
            type: GET_SETTINGS_COMPANIES_SUCCESS,
            payload: result,
        });
    } catch (e) {
        yield put({
            type: GET_SETTINGS_COMPANIES_ERROR,
        });
    }
}

const startAutoUpdateConfigSaga = function*() {
    const isOpenRepresentation = yield select(openSelector);

    if (!isOpenRepresentation) {
        taskUpdateConfig = yield fork(backgroundSyncListSaga);
    }
};

const stopAutoUpdateConfigSaga = function* () {
    if (taskUpdateConfig) {
        yield cancel(taskUpdateConfig);
        taskUpdateConfig = null;
    }
};

export const backgroundSyncListSaga = function* () {
    try {
        while (true) {
            yield put(getUserProfile());
            yield delay(600000);
        }
    } finally {
        if (yield cancelled()) {
            console.log('---', 'cancelled sync saga!!');
        }
    }
};

export function* saga() {
    yield all([
        takeEvery(GET_USER_PROFILE_REQUEST, getUserProfileSaga),
        takeEvery(GET_PROFILE_SETTINGS_REQUEST, getProfileSettingsSaga),
        takeEvery(EDIT_PROFILE_SETTINGS_REQUEST, editProfileSettingsSaga),
        takeEvery(CHANGE_PASSWORD_REQUEST, changePasswordSaga),
        takeEvery(GET_NOTIFICATIONS_LIST_REQUEST, getNotificationsListSaga),
        takeEvery(START_AUTO_UPDATE, startAutoUpdateConfigSaga),
        takeEvery(STOP_AUTO_UPDATE, stopAutoUpdateConfigSaga),
        takeEvery(GET_SETTINGS_COMPANIES_REQUEST, getCompaniesSaga),
    ]);
}
